export function excelParadasState() {
  return { excel: { data: null, status: {}, requestId: 0 } };
}

export const excelParadasMutations = {
  excelRequest(state) { state.excel.requestId += 1; state.excel.data = null; state.excel.status = { loading: true }; },
  excelSuccess(state, data) { state.excel.data = data; state.excel.status = { loaded: true }; },
  excelError(state, error) { state.excel.data = null; state.excel.status = { error }; },
  resetExcel(state) { state.excel.requestId += 1; state.excel.data = null; state.excel.status = {}; },
};

export function excelParadasActions(getService) {
  return {
    resetExcel({ commit }) { commit("resetExcel"); },
    async downloadExcel({ state, commit }, filters) {
      if (state.excel.status.loading) return;
      commit("excelRequest");
      const requestId = state.excel.requestId;
      try {
        const data = await getService().getParadasExcel(filters);
        if (requestId === state.excel.requestId) commit("excelSuccess", data);
      } catch (error) {
        if (requestId === state.excel.requestId) commit("excelError", error);
      }
    },
  };
}
